<template>
  <div class="about">
    <div class="body">
      <h1>开始使用</h1>
      <div class="nav">
        <div>
          <img src="../../assets/221e6fa5c09b716767f0b33963c0aa5.png" alt="" />
          <span>扫码安装</span>
        </div>
        <div class="heng"></div>
        <div>
          <img src="../../assets/b3a0526bf560c8b47ae9092c9df41eb.png" alt="" />
          <span>填写信息</span>
        </div>
        <div class="heng"></div>
        <div>
          <img src="../../assets/tow.png" alt="" />
          <span>授权给微炬云</span>
        </div>
      </div>
      <div class="logo">
        <div>
          <img src="../../assets/logoweiju.png" alt="" />
        </div>
        <div class="dashed"></div>
        <div>
          <img src="../../assets/logoqiyeweix.png" alt="" />
        </div>
      </div>
      <div class="information">
        <div>
          <div></div>
          <span>使用需要通过「授权给微炬云」来进行企业验证 </span>
        </div>
        <div>
          <div></div>
          <span>未注册企业微信的用户请先注册企业微信</span>
        </div>
      </div>
      <div class="bottom">
        <div class="nnne" @click="bo">
          <div class="none">
            <img src="../../assets/zdsdg.png" alt="" />
            <span class="sizi">去企业微信授权</span>
          </div>
        </div>
        <h2>或</h2>
        <a
          href="https://work.weixin.qq.com/wework_admin/register_wx?from=myhome_baidu"
        >
          <div class="nonb">
            <div class="none">
              <img src="../../assets/zasdf.png" alt="" />
              <span class="sizo">去企业微信注册</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tooken: {},
      returnUrl: "",
    };
  },
  mounted() {
    
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
  },
  methods: {
    bo() {
      if (!this.tooken.returnUrl) {
        this.$message.error('您还没有注册企业微信，请注册后再进行授权')
        return
      }
      location.href = this.tooken.returnUrl;
    },
  },
};
</script>
<style scoped>
.about {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
h1 {
  text-align: center;
}
.body {
  width: 60%;
  height: 100%;
  padding: 10.0rem;
  margin: 0 auto;
}
.nav {
  width: 60%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 5.0rem;
}
.nav > div {
  width: 12.0rem;
  display: inline-block;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.nav > div > span {
  color: #5f5f5f;
}
.heng {
  width: 8.0rem;
  border-bottom: 1px solid #1890ff;
}
.logo {
  width: 40%;
  margin: 0 auto;
  margin-top: 5.0rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.logo > div {
  display: inline-block;
}
.dashed {
  width: 13.0rem;
  border-bottom: 1px dashed #989898;
}
.information {
  width: 60%;
  height: 15.0rem;
  margin: 0 auto;
  margin-top: 5.0rem;
  border: 1px solid rgba(223, 229, 239, 1);
  background-color: #fafcff;
  padding: 10.0rem;
  padding-top: 4.0rem;
  border-radius: 4px;
}
.information > div:nth-child(2) {
  display: flex;
  align-items: center;
  margin-top: 2.0rem;
}
.information > div > div {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: #24be48;
}
.information > div > span {
  margin-left: 2.0rem;
  color: #5f5f5f;
}
.bottom {
  width: 50%;
  margin: 0 auto;
  margin-top: 5.0rem;
}
.nnne {
  width: 100%;
  height: 6.0rem;
  background-color: #1890ff;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
}
.nonb {
  width: 100%;
  height: 6.0rem;
  background-color: #ffffff;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  border: 2px solid #1890ff;
  cursor: pointer;
}
.none {
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 18px;
}
.bottom > h2 {
  text-align: center;
  font-weight: 400;
  margin: 1.0rem 0;
}
.sizi {
  color: #ffffff;
  margin-left: 1.0rem;
}
.sizo {
  color: #1890ff;
  margin-left: 1.0rem;
}
</style>